import React from "react"

import Layout from "../components/allstar/layout"

import SectionBody from "../components/allstar/key-findings/section-body"
import { graphql } from "gatsby"

const KeyFindingsPage = props => {
  return (
    <Layout location={props.location} title={"Key Findings"}>
      <SectionBody data={props.data} />
    </Layout>
  )
}

export default KeyFindingsPage

export const query = graphql`
  query keyFindingPage {
    allBadges: allFile(
      filter: { relativeDirectory: { eq: "allstar/badges" } }
    ) {
      edges {
        node {
          name
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`
